<template>
  <v-container fluid class="company-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Company</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Company</p>
                        <v-text-field
                          class="mb-4"
                          v-model="company.companycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Company Code"
                          persistent-hint
                          single-line hint="Enter the company Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="company.companyname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Company Name"
                          persistent-hint
                          single-line hint="Enter the company name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="company.companytype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the company type">
                        </v-select>
                          <v-switch
                            v-model="company.companystatus"
                            color="primary"
                            v-bind:label="company.companystatus"
                            value="Active"
                          ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="company.useremail"
                          v-bind:error="errorindex == 10"
                          outlined
                          dense
                          placeholder="User Email"
                          persistent-hint
                          single-line hint="Enter the user email">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="company.username"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="User Name"
                          persistent-hint
                          single-line hint="Enter the user name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="company.userpassword"
                          v-bind:error="errorindex == 12"
                          outlined
                          dense
                          placeholder="User Password"
                          persistent-hint
                          single-line hint="Enter the user password">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/company/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertCompany()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      company: {
        companystatus: 'Active'
      },
      items: ['Company', 'Other Company'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Company', [ 'insertCompanyRequest', 'getCompanysRequest']),
    checkError(){
      if(!this.company.companycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.company.companyname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.company.companytype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertCompany() {
      await this.insertCompanyRequest(this.company);
      router.push('/company/list');
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.company.companyimage = file;
      this.company.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Company', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
